import { UPDATE_SITE_COLORS, UPDATE_STYLE_PARAMS_COLORS } from '../actions';
import _get from 'lodash/get';
import { Reducer } from 'redux';

export const colors: Reducer = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_SITE_COLORS: {
      const colorsObj = (action.colors || []).reduce((acc, curr) => {
        return { ...acc, [curr.reference]: curr.value };
      }, {});
      const {
        'color-1': color1,
        'color-5': color5,
        'color-8': color8,
      } = colorsObj;
      return { ...state, color1, color5, color8 };
    }
    case UPDATE_STYLE_PARAMS_COLORS: {
      const primaryColor = _get(action.colors, 'primaryColor.value');
      const textColor = _get(action.colors, 'textColor.value');
      const headerTextColor = _get(action.colors, 'headerTextColor.value');
      const addPanelColor = _get(action.colors, 'primaryColor_addPanel.value');
      const addPanelTextColor = _get(action.colors, 'textColor_addPanel.value');
      return {
        ...state,
        primaryColor,
        textColor,
        headerTextColor,
        addPanelColor,
        addPanelTextColor,
      };
    }
    default:
      return state;
  }
};

export default colors;
